module.exports = __webpack_public_path__ + "static/media/2025_Greenland_Travel.afd666d3.png";